/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import { useDispatch } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setWarningAlerts } from "../../../globalStore/alertStore"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import CourseKyoriTarihuService from "../../../service/billing/courseKyoriTarihu/courseKyoriTarihuService"
import { TCourseKyoriTarihuListInfoGetRes } from "../../../service/billing/courseKyoriTarihu/TCourseKyoriTarihu"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"

import util from "../../../ts/util"
import { メニューコード } from "../../../constant/menuCode"

//#region dummy
export const 荷主ダミー = [
  { 荷主名: "アーステック株式会社", 荷主コード: "100001" },
  { 荷主名: "アサヒロジ株式会社", 荷主コード: "100002" },
]

//#endregion

/**
 * コース距離タリフ一覧
 * @returns
 */
const CourseKyoriTarihuList = () => {
  const history = useHistory()
  const location = useLocation()

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "CourseKyoriTarihuList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TCourseKyoriTarihuListInfoGetRes>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {},

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    try {
      const res = await new CourseKyoriTarihuService().getListInfo()
      // formatItemを入れなおすためフラグを切り替え
      ref明細フォーマットフラグ.current = false

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      // dispatch(setAlerts(error))
      dispatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `コース距離運賃タリフ登録`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      search()
      dispatch(画面ロック解除())
    }
  }, [gridInitialized])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">コース距離運賃タリフ登録</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>

      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                headerComponent={
                  <Link
                    to={
                      util.getMenuPath(
                        メニューコード.請求_支払管理.コース距離タリフ登録
                      )[0]
                    }
                    onClick={() =>
                      gridPageHelper.savePageConditionData(location.pathname)
                    }>
                    <Button disabled={isSearching}>
                      <FontAwesomeIcon icon={faPlusSquare} />
                      新規荷主登録
                    </Button>
                  </Link>
                }>
                <wjrGrid.FlexGridColumn
                  header=" "
                  allowMerging="true"
                  allowDragging={wjcGrid.AllowDragging.None}
                  align="center"
                  width={60}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TCourseKyoriTarihuListInfoGetRes>
                    ) => {
                      // パス設定
                      const url = util.getMenuPath(
                        メニューコード.請求_支払管理.コース距離タリフ登録
                      )[1]
                      return (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )
                            history.push(
                              url.replaceAll(
                                ":id",
                                context.item.荷主ID.toString()
                              )
                            )
                          }}>
                          編集
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主コード"
                  width={120}
                  header="コード"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主名"
                  width={160}
                  header="荷主名"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default CourseKyoriTarihuList
